<template>
    <div>
        <div class="registerLayout">
            <div class="regContainer">
                <!-- 内容列表 -->
                <div class="regList">
                    <!-- <el-scrollbar ref="multipleTable"> -->
                    <div class="top-tips">温馨提示： 标志*为必填项目 注意：如发现客户拥有多个账户，其帐户将会被冻结并且取消所有胜出的投注，恕不另行通知。</div>

                    <div class="regRow regAccountNumber">
                        <div class="input-label">{{ $t('loginPage.account') }}</div>
                        <input v-if="window.mergeAccount" class="logInput" v-model="accountNumber" maxlength="13"
                            @blur="accountBlur" autofocus />
                        <input v-else class="logInput" v-model="accountNumber" maxlength="15" @blur="accountBlur"
                            autofocus />
                        <div class="rowkey">
                            <span class="required">*</span>
                            <span>{{ $t('registerPage.accountV') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a">{{ errors.account }}</div>

                    <div class="regRow regPassword">
                        <div class="input-label">{{ $t('loginPage.password') }}</div>
                        <input type="password" class="logInput" v-model="password" @blur="passwordBlur" />
                        <div class="rowkey">
                            <span class="required">*</span>
                            <span>{{ $t('registerPage.passwordV') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a">{{ errors.password }}</div>

                    <div class="regRow regPassword">
                        <div class="input-label">确认{{ $t('loginPage.password') }}</div>

                        <input type="password" class="logInput" v-model="confirmPassword" @blur="confirmPasswordBlur" />
                        <div class="rowkey">
                            <span class="required">*</span>
                            <span>{{ $t('registerPage.passwordV') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a">{{ errors.confirmPassword }}</div>

                    <div class="regRow regPhone" v-if="regFlag && regFlag.phone">
                        <div class="input-label">{{ $t('registerPage.phone') }}</div>
                        <input type="text" class="logInput" maxlength="11" v-model="phone" @blur="phone = toCDB(phone)" />
                        <div class="rowkey">
                            <span class="required" v-if="regFlag.phone == 2">*</span>
                            <span v-if="regFlag.phone == 1">{{ $t('registerPage.phoneP') }}{{ $t('registerPage.optional')
                            }}</span>
                            <span v-else>{{ $t('registerPage.phoneP') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.phone">{{ errors.phone }}</div>
                    <div class="regRow regPhone" v-if="regFlag && regFlag.smsCode">
                        <div class="input-label" style="font-size:12px">短信验证码</div>
                        <input type="text" class="logInput" maxlength="8" v-model="smsCode">
                        <el-button @click="getSmsCode" size="small" type="success" style="margin-left:10px"
                            :disabled="!!(smsCoolDown)">{{ smsCoolDown ? (smsCoolDown + 's') : '获取验证码' }}</el-button>
                    </div>

                    <div class="regRow regCode" v-if="regFlag && regFlag.inviteCode">
                        <div class="input-label">{{ $t('registerPage.inviteCode') }}</div>

                        <input v-if="sessData" type="text" class="logInput" v-model="inviteCode" @blur="inviteCodeBlur"
                            :disabled="inviteCode ? true : false" />
                        <input v-else type="text" class="logInput" v-model="inviteCode" @blur="inviteCodeBlur" />
                        <div class="rowkey">
                            <span class="required" v-if="regFlag.inviteCode == 2">*</span>
                            <span v-if="regFlag.inviteCode == 1">{{
                                $t('registerPage.inviteCodeP') }}{{ $t('registerPage.optional') }}</span>
                            <span v-else>{{ $t('registerPage.inviteCodeP') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.inviteCode">{{ errors.inviteCode }}</div>

                    <!-- 姓名 -->
                    <div class="regRow regRealName" v-if="regFlag && regFlag.realName">
                        <div class="input-label">{{ $t('validLoginPage.realName') }}</div>

                        <input type="text" class="logInput" v-model="realName" />
                        <div class="rowkey">
                            <span class="required" v-if="regFlag.realName == 2">*</span>
                            <span v-if="regFlag.realName == 1">{{
                                $t('registerPage.realNameP') }}{{ $t('registerPage.optional') }}</span>
                            <span v-else>{{ $t('registerPage.realNameP') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.realName">{{ errors.realName }}</div>

                    <!-- 性别 -->
                    <div class="regRow regSex" v-if="regFlag && regFlag.sex">
                        <div class="input-label">{{ $t('registerPage.sex') }}</div>

                        <div class="maleSex cursorPoint" @click="sex = 1" style="margin-right:0.5rem;">
                            <img loading="lazy" class="sexImg"
                                v-lazy="sex == 1 ? require('../../static/image/pn/regChecked.png') : require('../../static/image/pn/regUnCheck.png')" />
                            <span class="btnTextColor">{{ $t('registerPage.male') }}</span>
                        </div>

                        <div class="femaleSex cursorPoint" @click="sex = 0">
                            <img loading="lazy" class="sexImg" v-lazy="sex == 0
                                    ? require('../../static/image/pn/regChecked.png')
                                    : require('../../static/image/pn/regUnCheck.png')
                                " />
                            <span class="btnTextColor">{{ $t('registerPage.female') }}</span>

                            <div class="rowkey">
                                <span class="required" v-if="regFlag.sex == 2">*</span>
                            </div>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.sex">{{ errors.phone }}</div>

                    <!--生日 -->
                    <div class="regRow regBirthday" v-if="regFlag && regFlag.birthday">
                        <div class="input-label">{{ $t('registerPage.birthday') }}</div>

                        <el-date-picker v-model="birthday" type="date"></el-date-picker>
                        <div class="rowkey">
                            <span class="required" v-if="regFlag.birthday == 2">*</span>
                            <span v-if="regFlag.birthday == 1">{{
                                $t('registerPage.birthdayP') }}{{ $t('registerPage.optional') }}</span>
                            <span v-else>{{ $t('registerPage.birthdayP') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.birthday">{{ errors.birthday }}</div>

                    <!-- 微信 -->
                    <div class="regRow regWechat" v-if="regFlag && regFlag.wechat">
                        <div class="input-label">{{ $t('registerPage.wechat') }}</div>
                        <input type="text" class="logInput" maxlength="20" v-model="wechat" />
                        <div class="rowkey">
                            <span class="required" v-if="regFlag.wechat == 2">*</span>
                            <span v-if="regFlag.wechat == 1">{{ $t('registerPage.wechatP') }}{{ $t('registerPage.optional')
                            }}</span>
                            <span v-else>{{ $t('registerPage.wechatP') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.wechat">{{ errors.wechat }}</div>

                    <!-- qq -->
                    <div class="regRow regQQ" v-if="regFlag && regFlag.qq">
                        <div class="input-label">{{ $t('registerPage.qq') }}</div>
                        <input type="text" class="logInput" maxlength="15" v-model="qq" />
                        <div class="rowkey">
                            <span class="required" v-if="regFlag.qq == 2">*</span>
                            <span v-if="regFlag.qq == 1">{{ $t('registerPage.qqP') }}{{ $t('registerPage.optional')
                            }}</span>
                            <span v-else>{{ $t('registerPage.qqP') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.qq">{{ errors.qq }}</div>

                    <!-- email -->
                    <div class="regRow regEmail" v-if="regFlag && regFlag.email">
                        <div class="input-label">{{ $t('registerPage.email') }}</div>
                        <input type="text" class="logInput" v-model="email" />
                        <div class="rowkey">
                            <span class="required" v-if="regFlag.email == 2">*</span>
                            <span v-if="regFlag.email == 1">{{ $t('registerPage.emailP') }}{{ $t('registerPage.optional')
                            }}</span>
                            <span v-else>{{ $t('registerPage.emailP') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.email">{{ errors.email }}</div>

                    <!-- 地址 -->
                    <div class="regRow regAddress" v-if="regFlag && regFlag.address">
                        <div class="input-label">{{ $t('registerPage.address') }}</div>

                        <input type="text" class="logInput" v-model="address" />
                        <div class="rowkey">
                            <span class="required" v-if="regFlag.address == 2">*</span>
                            <span v-if="regFlag.address == 1">{{ $t('registerPage.addressP') }}{{
                                $t('registerPage.optional')
                            }}</span>
                            <span v-else>{{ $t('registerPage.addressP') }}</span>
                        </div>
                    </div>
                    <div class="logErrMsg u-flex-a" v-if="regFlag && regFlag.address">{{ errors.address }}</div>
                    <!-- </el-scrollbar> -->
                </div>

                <!-- 验证码 -->
                <div v-show="type === 0" class="regRow logVerifyCode">
                    <div class="input-label">{{ $t('loginPage.verifyCode') }}</div>
                    <input type="text" class="logInput" v-model="captchaCode" @keyup.enter="register()"
                        @blur="captchaCode = toCDB(captchaCode)" />
                    <div class="verifyCodeImg cursorPoint" v-if="verifyCodeImg"
                        :style="'background-image:url(' + verifyCodeImg + ')'" @click="captchaData"></div>
                    <div class="verifyCodeImg getCode u-flex-all cursorPoint" v-if="!verifyCodeImg" @click="captchaData">
                        <img loading="lazy" v-lazy="require('../../assets/images/qiqi/refresh.png')" class="refimg" />
                        {{ $t('loginPage.regain') }}
                    </div>

                    <div class="rowkey updateColor">
                        <span class="required">*</span>
                        <span>{{ $t('loginPage.verifyCodeP') }}</span>
                    </div>
                </div>
                <!-- 行为校验  树莓 -->
                <div v-show="type === 2" id="captcha" class="loginBtn captchaStyle" @click="captchaClick">{{ captchaText }}
                </div>
                <!--  行为验证 急眼 -->
                <div v-show="type === 1" id="captcha2" class></div>
                <!--  行为验证 极验4 -->
                <div v-show="type === 3" id="gt41" class="gt41"></div>
                <div v-if="errorCode" class="getCode u-flex-all cursorPoint" style="width:2.7rem;"
                    @click="getDefaultStatus">
                    <img loading="lazy" v-lazy="require('../../assets/images/qiqi/refresh.png')" class="refimg" alt />
                    {{ $t('loginPage.regain') }}
                </div>

                <div class="regAgreement">
                    <img loading="lazy" class="regCheckBox cursorPoint" v-lazy="!isSelect
                        ? require('../../static/image/pn/regUnCheck.png')
                        : require('../../static/image/pn/regChecked.png')" @click="switchSelect" />
                    <div class="regAgreementCont" style="margin-left:0.09rem;">{{ $t('registerPage.agree') }}
                        {{ $t('registerPage.userAgreement') }}</div>
                </div>

                <div class="submit-btn registerBtn u-flex-all cursorPoint buttonHover1" @click="register()">
                    {{ $t('registerPage.register') }}</div>

                <div class="bottom-tips">
                    <span style="color:red;">温馨提示：标志*为必填项目</span>
                    <span>请勿填写错误详细资料，以免影响优惠发放；注册手机请绑定本人常用手机号码，请及时认证，保证信息安全，如号码有变更，请及时联系客服修改！</span>
                </div>
            </div>
            <div class="regRight">
                <img loading="lazy" v-lazy="require('../../assets/images/qiqi/regRight.png')" alt />
            </div>
        </div>
        <div class="showact" v-if="activityList.length > 0">
            <div class="n-reg-bt">{{ $t('activityPage.hotAct') }}</div>
            <div class="box">
                <div class="list" v-for="(item, index) in activityList" :key="index" @click="openDis(item)">
                    <img loading="lazy" v-lazy="$config.imgHost + item.picture" alt />
                    <div class="title">{{ item.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import { showLogin } from "../login/login.js";
import { _getDeviceId } from '@/utils/finger'
import store from "../../store/store";
import gt from "../../utils/gt.js";
import "../../utils/smcp.min.js";
import "../../utils/boc"
export default {
    name: "register",
    data() {
        return {
            loading: false,
            activityList: [], //活动前三个
            accountNumber: "",
            password: "",
            confirmPassword: "",
            phone: "",
            inviteCode: "",
            isSelect: true, //默认选中协议
            disabled: true,
            errors: {},
            isClickRegister: true, //只有第一次注册生效
            window: window,
            sessData: "",
            realName: "",
            sex: 1,
            birthday: "",
            wechat: "",
            qq: "",
            email: "",
            address: "",
            regFlag: null, //注册设置
            captchaCode: "",
            captchaKey: "",
            verifyCodeImg: "",
            type: 1, //行为校验2
            captcha: null, //行为校验
            captchaBox: null,
            captchaText: "",
            captchaMask: false,
            errorCode: false,
            smsCode: '', // 短信验证码
            smsCoolDown: 0,
            smsInterval: 0,
            // 数美请求参数
            smData: {
                lang: '',
                mode: '',
                organization: '',
                product: '',
                appId: '',
                channel: '',
            },
            fingerprintState: false
        };
    },
    mounted() {
        this.initRequest();
        this.getActivityData();
    },
    methods: {
        // 获取验证码
        async getSmsCode() {
            if (!this.phone) return this.$message.warning('请先输入手机号')
            if (!this.phoneIsValid()) return this.$message.warning('手机号格式有误')
            if (this.loading) return
            const res = await this.$http.get(
                this.$api.sendSmsCode,
                '/' + this.phone + '?functionId=8'
            )
            this.loading = false
            if (res.code == 0) {
                this.$message.success('验证码已发送')
                this.smsCoolDown = 59
                this.smsInterval = setInterval(() => {
                    this.smsCoolDown--
                    if (this.smsCoolDown <= 0) {
                        clearInterval(this.smsInterval)
                    }
                }, 1000)
            } else {
                this.$message.error(res.msg || '获取验证码失败')
            }
        },
        // 优惠活动
        async getActivityData() {
            var _this = this;
            var data = {
                currentPage: 1,
                pageSize: 3
            };
            var res = await _this.$http.post(_this.$api.activity, data);
            if (res.code == 0) {
                this.activityList = res.data.content;
            } else {
                this.$message.error(res.msg);
            }
        },
        //活动详情
        openDis(item) {
            if (item.type == 7) {
                if (item.needLogin == 1 && !this.$common.getUser()) {
                    this.$message.warning('请先登录！')
                    return
                }
                return this.$router.push({
                    path: url
                });
            }
            if (item.type == 3 && item.activityExtensionsVo.url) {
                //跳转链接
                window.open(item.activityExtensionsVo.url);
            } else if (
                item.activityExtensionsVo &&
                item.activityExtensionsVo.type == 4
            ) {
                //跳转游戏
                if (!this.$common.getUser()) {
                    this.$message.warning('请先登录！');
                } else {
                    this.getToken(item.activityExtensionsVo.activityGame, 1);
                }
            } else {
                //打开活动详情
                this.$router.push({
                    path: "/discount",
                    query: {
                        id: item.id
                    }
                });
            }
        },
        // 进入游戏
        getToken: async function (req, index) {
            let self = this;
            var issafariBrowser =
                /Safari/.test(navigator.userAgent) &&
                !/Chrome/.test(navigator.userAgent);

            if (!self.$common.getUser()) {
                self.$message.warning("请登录");
                return;
            }
            self.tenantId = self.$common.getUser().tenant_id;
            self.username = self.$common.getUser().username;
            self.uid = self.$common.getUser().user_id;
            let datas = {
                tenantId: self.tenantId,
                username: self.username,
                gameId: index == 2 ? req.ids : req.id,
                clientIp: self.$config.clientIp,
                memberId: self.uid,
                terminalType: 1
            };
            self.$common.setGameRequestData(datas);

            const res = await self.$http.post(this.$api.getToken, datas, true);
            if (res.code == 0) {
                self.gameUrl = res.data;
                if (req.openMode === 1) {
                    // if(issafariBrowser) {
                    //  self.winOpen.location.href = self.gameUrl;
                    // }else{
                    window.open(self.gameUrl);
                    // }
                } else {
                    window.open(self.gameUrl);
                }
            } else {
                if (req.openMode === 1) {
                    window.open("/error.html?type=1");
                    // self.winOpen.location.href = '/error.html?type=1';
                }

                if (req.status === 0) {
                    self.$message.error("维护中");
                } else {
                    self.$message.error("进入游戏失败，请稍后重试！");
                }
            }
        },
        initRequest() {
            //初始化数据
            this.accountNumber = "";
            this.password = "";
            this.confirmPassword = "";
            this.phone = "";
            this.sessData = JSON.parse(sessionStorage.getItem("inviteCode"));
            this.inviteCode = this.sessData || "";
            this.realName = "";
            this.sex = 1;
            this.birthday = "";
            this.wechat = "";
            this.qq = "";
            this.email = "";
            this.address = "";
            this.captchaCode = "";
            this.isSelect = true;
            this.disabled = true;
            this.isClickRegister = true;
            this.getRegisterSet();
            this.getDefaultStatus();
            var _this = this;
            this.$nextTick(() => {
                var container = document.querySelector(".regList");
                if (container.offsetHeight > 300) {
                    container.style.height = "3rem";
                }
            });
        },
        getDefaultStatus() {
            let _this = this;
            this.$http.get(this.$api.getDefaultStatus, false).then(res => {
                if (res.code == 0) {
                    // type   0：默认验证码  1：极验  2：数美"
                    _this.type = res.data.type;
                    //  _this.type = 2
                    if (_this.type === 0) {
                        //图片验证码
                        //获取验证码图片
                        this.captchaData();
                    } else if (_this.type === 1 || _this.type === 3) {
                        //1：极验
                        _this.disabled = false;
                        _this.reset();
                    } else if (_this.type === 2) {
                        //2：数美"
                        Object.assign(_this.smData, res.data);
                        _this.reset();
                    }
                    _this.fingerprintState = res.data.fingerprintState
                    if (res.data.fingerprintState) {
                        _getDeviceId(res.data.fingerprintId).then(res => {
                            _this.$config.fingerprint = res
                            sessionStorage.setItem('fingerprint', res);
                        })
                    }
                } else {
                    this.errorCode = true;
                    this.type = null;
                    this.moneyModeListReqSuccess = false;
                    this.$http.showMesasge(this.$t("loginPage.loadFail"));
                }
            });
        },
        //行为校验↓
        reset() {
            this.check();
            this.getCaptcha();
        },
        check() {
            if (this.type === 3) {
                this.captcha && this.captcha.reset()
            } else {
                if (this.captcha) {
                    this.captchaText = "";
                } else {
                    this.captchaText = this.$t("loginPage.loading");
                }
            }
        },
        getCaptcha() {
            let lang = "zh";
            if (this.$config.local == "en_US") {
                lang = "en";
            } else if (this.$config.local == "zh_CN") {
                lang = "zh-cn";
            } else if (this.$config.local == "zh_HK") {
                lang = "zh-hk";
            }
            if (this.type == 1) {
                let _this = this;
                this.$http
                    .get(
                        this.$api.geetFirstRegister,
                        "?t=" + window.childCode,
                        false
                    )
                    .then(res => {
                        if (res.code == 0) {
                            window.initGeetest(
                                {
                                    gt: res.data.gt,
                                    challenge: res.data.challenge,
                                    new_captcha: res.data.newCaptcha, // 用于宕机时表示是新验证码的宕机
                                    offline:
                                        res.data.success === 1 ? false : true, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
                                    product: "float", // 产品形式，包括：float，popup
                                    width: "100%",
                                    lang: lang
                                },
                                _this.onCaptcha
                            );
                        } else {
                            this.$http.showMesasge(
                                this.$t("loginPage.getError")
                            );
                        }
                    });
            } else if (this.type == 2) {
                let data = {
                    ...this.smData,
                    width: 300,
                    https: location.protocol == "https:"
                };
                initSMCaptcha(
                    data,
                    this.onCaptcha
                );
            } else if (this.type === 3) {
                if (!this.captcha) {
                    initBotion({
                        captchaId: this.$config.captchaId,
                        product: 'popup',//float  popup
                        language: lang,
                        nativeButton: {
                            width: '2.7rem',
                            height: '0.4rem'
                        }
                    }, this.onCaptcha);
                }
            }
        },
        onCaptcha(res) {
            //res是验证实例，可以调用res的示例方法
            var _this = this;
            this.captcha = res;
            if (_this.type == 1) {
                res.appendTo("#captcha2");
                res.onReady(_this.check);
            } else if (this.type == 2) {
                this.captchaText = _this.$t("loginPage.clickBtnToVerify");
                this.captcha.onSuccess(function (data) {
                    if (data.pass) {
                        _this.disabled = false;
                        _this.captcha.rid = data.rid;
                        _this.captchaText = _this.$t("loginPage.verifySuccess");
                        _this.captchaMask = false;
                    } else {
                        _this.captcha.rid = null;
                        _this.captchaText = _this.$t("loginPage.verifyFail");
                    }
                });

                this.captcha.onError(function (errType, errMsg) {
                    _this.captcha.rid = null;
                    _this.captchaText = _this.$t("loginPage.verifyFail");
                    _this.captchaMask = false;
                });

                this.captcha.onClose(function () {
                    _this.captchaMask = false;
                });
            } else if (this.type === 3) {
                res.appendTo("#gt41");
            }
        },
        captchaClick() {
            if (this.type == 2) {
                var result = this.captcha.getResult();
                var pass = result.pass;
                if (!pass) {
                    this.captcha.verify();
                    //行为验证bug:点击关闭按钮，会点击穿透
                    //解决：手动再添加一个遮罩层
                    this.captchaMask = true;
                }
            }
        },
        captchaData: async function (type) {
            let _this = this;
            const res = await this.$http.get(_this.$api.captcha);
            if (res.code == 0) {
                _this.verifyCodeImg = res.data.captcha_image_content;
                // _this.captchaCode = res.data.captchaCode;
                _this.captchaKey = res.data.captchaKey;
            } else {
                // this.$http.showMesasge(res.msg + "");
            }
        },
        async getRegisterSet() {
            var _this = this;
            var key = "member_register";
            let res = await this.$http.get(this.$api.getRegisterSet, key);
            if (res.code == 0) {
                _this.regFlag = res.data.svalue;
            }
        },
        switchSelect() {
            this.isSelect = !this.isSelect;
        },
        registerIsDisabled() {
            //注册按钮是否禁用
            var oldIsDisable = true;
            if (this.type === 0) {
                oldIsDisable =
                    this.accountNumber &&
                    this.password &&
                    this.confirmPassword &&
                    this.isSelect &&
                    this.captchaCode;
            }
            var requiredFields = [];
            var flag = false;
            if (this.regFlag) {
                for (var k in this.regFlag) {
                    flag = true;
                    if (this.regFlag[k] == 2) {
                        requiredFields.push(k);
                    }
                }
            }

            if (flag) {
                var boolean = true;
                for (var i = 0; i < requiredFields.length; i++) {
                    if (requiredFields[i] != "sex") {
                        boolean *= Boolean(this[requiredFields[i]]);
                    }
                }
            }

            var newIsDisable = boolean;
            if (oldIsDisable && newIsDisable) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        },
        accountFocus() {
            //聚焦，提示
            this.errors = {};
            if (window.mergeAccount) {
                this.$set(
                    this.errors,
                    "account",
                    this.$t("agentRegister.accountPostF")
                );
            } else {
                this.$set(
                    this.errors,
                    "account",
                    this.$t("agentRegister.accountF")
                );
            }
        },
        passwordFocus() {
            //聚焦，提示
            this.errors = {};
            this.$set(
                this.errors,
                "password",
                this.$t("agentRegister.passwordF")
            );
        },
        inviteCodeFocus() {
            //聚焦，提示
            this.errors = {};
            // this.$set(
            //     this.errors,
            //     "inviteCode",
            //     this.$t("registerPage.inviteCodeF")
            // );
        },
        accountBlur() {
            //大写字母强制转化为小写
            this.accountNumber = this.accountNumber.toLowerCase();
            //全角转半角
            this.accountNumber = this.toCDB(this.accountNumber);
            //删除所有空格
            this.accountNumber = this.accountNumber.replace(/\ /g, "");
            this.errors.account = "";
        },
        passwordBlur() {
            // this.password = this.password.toLowerCase();
            //全角转半角
            this.password = this.toCDB(this.password);
            //删除所有空格
            // this.password = this.password.replace(/\ /g, "");
            this.errors.password = "";
        },
        confirmPasswordBlur() {
            // this.confirmPassword = this.confirmPassword.toLowerCase();
            //全角转半角
            this.confirmPassword = this.toCDB(this.confirmPassword);
            // this.confirmPassword = this.confirmPassword.replace(/\ /g, "");
        },
        inviteCodeBlur() {
            //全角转半角
            this.inviteCode = this.toCDB(this.inviteCode);
            this.errors.inviteCode = "";
        },
        inviteCodeValid() {
            //邀请码校验
            if (this.inviteCode) {
                return /^[a-zA-Z0-9]*$/.test(this.inviteCode);
            } else {
                return true;
            }
        },
        accountIsValid() {
            //账号校验
            return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,15}$/.test(
                this.accountNumber
            );
        },
        passwordIsValid() {
            //密码校验
            // return /^[a-zA-Z0-9]{6,15}$/.test(this.password);
            return true
        },
        passwordIsconfirmPassword() {
            //密码和确认密码是否相同
            return this.password == this.confirmPassword;
        },
        phoneIsValid() {
            //手机格式校验
            if (this.phone) {
                return /^1[3456789]\d{9}$/.test(this.phone);
            } else {
                return true;
            }
        },
        // realNameIsValid() {
        //   //真实姓名校验
        //   if (this.realName) {
        //     return /^.{0,8}$/.test(this.realName);
        //   } else {
        //     return true;
        //   }
        // },
        WeChatIsValid() {
            //微信号校验
            if (this.wechat) {
                return /^[a-zA-Z0-9][a-zA-Z0-9_-]{5,19}$/.test(this.wechat);
            } else {
                return true;
            }
        },
        qqIsValid() {
            //qq校验
            if (this.qq) {
                return /^[1-9][0-9]{4,14}$/.test(this.qq);
            } else {
                return true;
            }
        },
        emailIsValid() {
            // email校验
            if (this.email) {
                return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(
                    this.email
                );
            } else {
                return true;
            }
        },
        toCDB(str) {
            //全角转为半角
            var tmp = "";
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) == 12288) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
                }
                if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
                } else {
                    tmp += String.fromCharCode(str.charCodeAt(i));
                }
            }
            return tmp;
        },
        timeSwitch(val) {
            if (val) {
                var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var time = Y + M + D;
                return time;
            }
        },
        getSubmitValue(key) {
            var _this = this;
            if (this.regFlag[key] == 0) {
                //不显示
                return null;
            } else if (_this[key] == "") {
                //选填未填
                return null;
            } else {
                //选填或必填
                if (key == "birthday") {
                    return _this.timeSwitch(_this.birthday);
                } else {
                    return _this[key];
                }
            }
        },
        async register() {
            let captcha2 = document.querySelector("#captcha2");
            var _this = this;
            //禁用
            if (_this.disabled) {
                if (this.regFlag.inviteCode == 2 && !this.inviteCode) {
                    //必填却没值
                    this.$http.showMesasge(this.$t("registerPage.inviteCodeE"));
                    return;
                } else if (!_this.accountNumber) {
                    this.$http.showMesasge(this.$t("loginPage.accountE"));
                    return;
                } else if (!_this.password) {
                    this.$http.showMesasge(this.$t("loginPage.passwordE"));
                    return;
                } else if (!_this.confirmPassword) {
                    this.$http.showMesasge(this.$t("registerPage.confirmPswE"));
                    return;
                } else if (this.regFlag.phone == 2 && !this.phone) {
                    this.$http.showMesasge(this.$t("registerPage.phoneE"));
                    return;
                } else if (this.regFlag.realName == 2 && !this.realName) {
                    this.$http.showMesasge(this.$t("registerPage.realNameE"));
                    return;
                } else if (this.regFlag.birthday == 2 && !this.birthday) {
                    this.$http.showMesasge(this.$t("registerPage.birthdayE"));
                    return;
                } else if (this.regFlag.wechat == 2 && !this.wechat) {
                    this.$http.showMesasge(this.$t("registerPage.wechatE"));
                    return;
                } else if (this.regFlag.qq == 2 && !this.qq) {
                    this.$http.showMesasge(this.$t("registerPage.qqE"));
                    return;
                } else if (this.regFlag.email == 2 && !this.email) {
                    this.$http.showMesasge(this.$t("registerPage.emailE"));
                    return;
                } else if (this.regFlag.address == 2 && !this.address) {
                    this.$http.showMesasge(this.$t("registerPage.addressE"));
                    return;
                } else if (this.type == 0 && !this.captchaCode) {
                    this.$http.showMesasge(this.$t("loginPage.verifyCodeE"));
                    return;
                } else if (!this.isSelect) {
                    this.$http.showMesasge(this.$t("registerPage.firstAgree"));
                    return;
                }

                return;
            }
            //正则校验
            if (!_this.accountIsValid()) {
                this.errors = {};
                if (window.mergeAccount) {
                    this.$http.showMesasge(
                        this.$t("registerPage.accountPostV")
                    );
                } else {
                    this.$http.showMesasge(this.$t("registerPage.accountV"));
                }

                return;
            } else if (!_this.passwordIsValid()) {
                this.errors = {};
                this.$http.showMesasge(this.$t("registerPage.passwordV"));
                return;
            } else if (!_this.passwordIsconfirmPassword()) {
                this.errors = {};
                this.$http.showMesasge(this.$t("registerPage.pswIscPsw"));
                return;
            } else if (!_this.phoneIsValid()) {
                this.errors = {};
                this.$http.showMesasge(this.$t("registerPage.phoneV"));
                return;
            } else if (!_this.inviteCodeValid()) {
                this.errors = {};
                this.$http.showMesasge(this.$t("registerPage.inviteCodeV"));
                return;
            }
            // else if (!this.realNameIsValid()) {
            //   this.errors = {};
            //   this.$http.showMesasge("姓名不能超过8位！");
            //   return;
            // }
            else if (!this.WeChatIsValid()) {
                this.errors = {};
                this.$http.showMesasge(this.$t("registerPage.wechatV"));
                return;
            } else if (!this.qqIsValid()) {
                this.errors = {};
                this.$http.showMesasge(this.$t("registerPage.qqV"));
                return;
            } else if (!this.emailIsValid()) {
                this.errors = {};
                this.$http.showMesasge(this.$t("registerPage.emailV"));
                return;
            }

            if (this.type != 0) {
                var result = this.captcha.getValidate();
                if (!result) {
                    this.$http.showMesasge(this.$t("loginPage.firstVerify"));
                    return;
                }
            }

            //禁止重复点击
            if (!this.isClickRegister) {
                return;
            }
            this.isClickRegister = false;

            //注册接口
            this.errors = {};
            var params = {
                phone: _this.getSubmitValue("phone"),
                smsCode: this.smsCode,
                username: _this.accountNumber,
                password: _this.password,
                inviteCode: _this.inviteCode,
                lastLoginVersion: _this.$config.loginVersion,
                realName: _this.getSubmitValue("realName"),
                sex: _this.getSubmitValue("sex"),
                birthday: _this.getSubmitValue("birthday"),
                wechat: _this.getSubmitValue("wechat"),
                qq: _this.getSubmitValue("qq"),
                email: _this.getSubmitValue("email"),
                address: _this.getSubmitValue("address"),
                validateType: this.type,
            };
            if (this.fingerprintState) {
                params.fingerprint = this.$config.fingerprint
                params.phoneModel = this.$config.phoneModel
            }
            //账号处理
            if (window.mergeAccount) {
                params.username = this.accountNumber + window.mergeAccount;
            }
            this.$set(params, "clientItem", window.childCode);
            this.$set(params, "appId", window.theme);

            if (this.type === 1) {
                params.geeTestQueryVO = {
                    challenge: result.geetest_challenge,
                    seccode: result.geetest_seccode,
                    validate: result.geetest_validate
                };
            } else if (this.type === 2) {
                params.shuMeiQueryVO = {
                    rid: result.rid
                };
            } else if (this.type === 0) {
                params.captchaKey = this.captchaKey;
                params.captchaCode = this.captchaCode;
            } else if (this.type === 3) {
                params.geeTestQueryVO = result
            }
            let res = await _this.$http.post(_this.$api.register, params);
            if (res.code == 0) {
                this.$common.setToken(res.data);
                this.$common.setUser(res.data);
                //注册成功
                this.$message({
                    message: _this.$t("registerPage.registerSuccess"),
                    type: "success"
                });

                sessionStorage.setItem("firstLogin", true);
                // sessionStorage.removeItem("inviteCode");
                store.commit("firstLogin", true);
                //获取个人信息
                this.$nkhttp.getUserInfo();
                //跳到首页
                this.$router.push("/");
                store.commit("advertisingShow", 1);
            } else {
                this.isClickRegister = true;
                this.$common.clearToken();
                this.$http.showMesasge(res.msg);

                if (_this.type === 1) {
                    captcha2.innerHTML = "";
                }
                this.getDefaultStatus();
            }
        }
    },
    watch: {
        accountNumber() {
            this.registerIsDisabled();
        },
        password() {
            this.registerIsDisabled();
        },
        confirmPassword() {
            this.registerIsDisabled();
        },
        phone() {
            this.registerIsDisabled();
        },
        isSelect() {
            this.registerIsDisabled();
        },
        realName() {
            this.registerIsDisabled();
        },
        sex() {
            this.registerIsDisabled();
        },
        birthday() {
            this.registerIsDisabled();
        },
        wechat() {
            this.registerIsDisabled();
        },
        qq() {
            this.registerIsDisabled();
        },
        email() {
            this.registerIsDisabled();
        },
        address() {
            this.registerIsDisabled();
        },
        captchaCode() {
            this.registerIsDisabled();
        }
    },
    beforeDestroy() {
        if (this.smsInterval) {
            clearInterval(this.smsInterval)
        }
    }
};
</script>

<style scoped>
.showact {
    width: 12rem;
    padding: 0 30px 15px;
    background-color: #fff;
    margin: 0 auto;
    margin-bottom: 20px;
    box-sizing: border-box;
}

.n-reg-bt {
    height: 56px;
    line-height: 56px;
    font-size: 15px;
    font-weight: 200;
}

.showact .box {
    overflow: hidden;
    display: flex;
}

.showact .list {
    flex: 1;
    height: 180px;
    margin-right: 30px;
    float: left;
}

.showact .list .title {
    background-color: #eee;
    height: 45px;
    line-height: 55px;
    padding: 0 10px;
}

.showact .list img {
    width: 100%;
    height: 135px;
}

.showact .list:last-child {
    margin-right: 0;
}

.getCode {
    height: 0.44rem;
    border-radius: 0.1rem;
    background: #f9f9f9;
    color: #313131;
}

.refimg {
    width: 0.22rem;
    vertical-align: middle;
}

.registerLayout {
    margin: 0.4rem auto 0.2rem;
    width: 12rem;
    padding-top: 0.2rem;
    background: #fff;
    box-sizing: border-box;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.04);
    display: flex;
}

.regContainer {
    flex: 1;
    border: 1px solid #eee;
    padding: 0 0.3rem 0.3rem;
    box-sizing: border-box;
}

.loginClose {
    position: absolute;
    top: 0.23rem;
    right: 0.23rem;
    width: 0.13rem;
    height: 0.13rem;
    cursor: pointer;
    transition: 1s;
}

.loginClose:hover {
    transform: rotate(180deg);
}

.regRow {
    display: flex;
    align-items: center;
}

.regRow .input-label {
    min-width: 1rem;
    font-weight: 600;
    line-height: 0.42rem;
    color: #333;
}

.regRow .rowkey {
    margin-left: 0.15rem;
    line-height: 0.4rem;
    padding-left: 0.3rem;
    box-sizing: border-box;
    font-size: 0.12rem;
    color: #999;
    position: relative;
}

.required {
    color: red;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0.1rem;
}

.regRow input {
    height: 0.4rem;
    line-height: 0.4rem;
    width: 2.7rem;
    padding: 0 0.05rem;
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #d0d0d0;
    border-radius: 2px;
    box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.06),
        inset 1px 1px 3px rgba(0, 0, 0, 0.06);
    font-size: 0.12rem;
}

.regRow input:focus {
    border-color: #77baff;
    box-shadow: 0 0 5px #a9d6ff;
}

.regSex {
    display: flex;
    /* padding-left: 0.1rem; */
}

.regSex .rowkey {
    height: auto;
    line-height: normal;
}

.regSex .sexImg {
    width: 0.14rem;
    height: 0.14rem;
    object-fit: cover;
    margin: 0 0.1rem 0 0.1rem;
}

.regCheckBox {
    width: 0.14rem;
    height: 0.14rem;
    background-size: cover;
    background-repeat: no-repeat;
}

.regAgreement {
    display: flex;
    align-items: center;
    margin-top: 0.2rem;
    padding-left: 1rem;
    box-sizing: border-box;
}

.regAgreementCont {
    font-size: 0.12rem;
    line-height: 0.15rem;
    word-break: break-word;
}

.registerBtn {
    width: 1.26rem;
    height: 0.4rem;
    margin: 0.2rem 0 0 1rem;
}

.logErrMsg {
    color: #f5726e;
    font-size: 0.11rem;
    height: 0.2rem;
    padding-left: 0.55rem;
}

.logErrMsg:last-child {
    height: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

input[type="number"] {
    -moz-appearance: textfield !important;
}

.logVerifyCode {
    display: flex;
    align-items: center;
    position: relative;
}

.logVerifyCode input {
    width: 1.8rem;
}

.logVerifyCode .rowkey {
    height: 0.44rem;
    line-height: 0.44rem;
    padding-left: 0.3rem;
    box-sizing: border-box;
    position: relative;
}

.logVerifyCode .verifyCodeImg {
    width: 0.8rem;
    height: 0.4rem;
    border-radius: 0.02rem;
    background: #ededed;
    background-size: 100% 100%;
    flex-shrink: 0;
    margin-left: 0.1rem;
}

#captcha2 {
    width: 2.7rem;
    height: 0.44rem;
    border-radius: 0.1rem;
    background: #ededed;
    margin-left: 1rem;
}

.top-tips {
    background: #fff4d7;
    line-height: 0.3rem;
    padding: 0 0.12rem;
    color: #f85a3f;
    font-size: 12px;
    margin: 0.18rem 0 0.27rem;
}

.bottom-tips {
    margin-top: 0.42rem;
    color: rgb(144, 144, 144);
    font-size: 0.13rem;
}

.regRight {
    padding-left: 0.1rem;
    border: 1px solid #eee;
    border-left: none;
    box-sizing: border-box;
}

.regRight img {
    width: 2.8rem;
    height: 4.48rem;
    flex-shrink: 0;
}
</style>
<style>
.registerLayout .regList {
    height: auto;
    overflow: auto;
    /* max-height: 5.1rem; */
    margin-bottom: 0.2rem;
}

/* 生日 */
.registerLayout .el-date-editor.el-input {
    width: 2.7rem;
}

.registerLayout .el-input__icon.el-icon-date {
    width: 0 !important;
}

.registerLayout .el-input__icon.el-icon-date::before {
    content: "" !important;
}

.registerLayout .el-input__inner {
    height: 0.4rem;
    line-height: 0.4rem;
    padding: 0 0.05rem;
    box-sizing: border-box;
    border: 1px solid #d0d0d0;
    border-radius: 2px;
    box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.06),
        inset 1px 1px 3px rgba(0, 0, 0, 0.06);
    font-size: 0.12rem;
    color: #999;
}

.registerLayout .el-input__inner:focus {
    border-color: #77baff;
    box-shadow: 0 0 5px #a9d6ff;
}

.registerLayout .el-scrollbar__wrap {
    overflow-x: hidden;
    padding-top: 0.05rem;
    padding-right: 0.2rem;
    box-sizing: border-box;
    max-height: 5.1rem;
}

.registerLayout .el-scrollbar__thumb {
    background-color: #ff3a2b;
    max-height: 5.1rem;
}

.registerLayout .el-scrollbar__bar.is-vertical {
    width: 0.06rem;
    background: #f4f4f4;
}

.registerLayout .captchaStyle {
    margin-left: 1rem;
    background-color: rgba(0, 0, 0, 0.4);
}

.registerLayout .captchaStyle:hover {
    background-color: rgba(0, 0, 0, 0.5);
}

.gt41 {
    margin-left: 1rem;
}
</style>
